// extracted by mini-css-extract-plugin
export default {"footer":"_2zTop","footerLeftSide":"_2-_XG","likesCount":"N9q17","commentsCountContainer":"_1kNc3","commentsCount":"_1Mq9O","tooltip":"mzRzr"};